export default {
    name: '이름',
    tel: '전화',
    save: '저장',
    confirm: '확인하다',
    cancel: '취소',
    delete: '삭제',
    complete: '마치다',
    loading: '로딩 중...',
    telEmpty: '전화번호를 기입해주세요',
    nameEmpty: '당신의 이름을 기입하십시오',
    nameInvalid: '유효한 이름을 입력하세요.',
    confirmDelete: '삭제 하시겠습니까',
    telInvalid: '정확한 전화번호를 입력하세요',
    vanCalendar: {
        end: '끝',
        start: '시작',
        title: '제목',
        confirm: '확인하다',
        startEnd: '시작 끝',
        weekdays: ['하루', '하나', '둘', '셋', '넷', '다섯', '여섯'],
    },
    vanCascader: {
        select: '선택해주세요',
    },
    vanContactCard: {
        addText: '연락처 추가',
    },
    vanContactList: {
        addText: '새 연락처',
    },
    vanPagination: {
        prev: '이전 페이지',
        next: '다음 페이지',
    },
    vanPullRefresh: {
        pulling: '아래로 당겨 새로고침...',
        loosing: '새로 고침 릴리스...',
    },
    vanSubmitBar: {
        label: '모두：',
    },
    vanCoupon: {
        unlimited: '사용 제한 없음',
    },
    vanCouponCell: {
        title: '쿠폰',
        tips: '사용할 수 없습니다',
    },
    vanCouponList: {
        empty: '쿠폰 없음',
        exchange: '교환',
        close: '쿠폰 없음',
        enable: '쓸 수 있는',
        disabled: '사용할 수 없습니다',
        placeholder: '프로모션 코드를 입력하세요',
    },
    vanAddressEdit: {
        area: '지역',
        postal: '우편 번호',
        areaEmpty: '지역 선택',
        addressEmpty: '자세한 주소를 기입해주세요',
        postalEmpty: '잘못된 우편번호 형식',
        defaultAddress: '기본 배송 주소로 설정',
        telPlaceholder: '수취인의 휴대폰 번호',
        namePlaceholder: '수취인 이름',
        areaPlaceholder: '지방/시/지역 선택',
    },
    vanAddressEditDetail: {
        label: '주소',
        placeholder: '도로명, 층수 등',
    },
    vanAddressList: {
        add: '주소 추가',
    },
};
